import { createBrowserClient } from "@supabase/ssr";

export function createClient() {
  return createBrowserClient(
    process.env.REACT_APP_SUPABASEURL!,
    process.env.REACT_APP_SUPABASEKEY!,
  );
}